// extracted by mini-css-extract-plugin
export var links = "footer-module--links--B3VTe";
export var svgs = "footer-module--svgs--3HvSa";
export var component = "footer-module--component--2eBW6";
export var svg = "footer-module--svg--1feYr";
export var link = "footer-module--link--3vcKH";
export var cube = "footer-module--cube--xc_8z";